"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATS_EVENTS = exports.stats = void 0;
const tslib_1 = require("tslib");
const events_1 = tslib_1.__importDefault(require("./events"));
exports.STATS_EVENTS = events_1.default;
const stats_1 = require("./stats");
/**
 * singleton interface for use by package
 * @type {Stats}
 */
const stats = new stats_1.Stats();
exports.stats = stats;
//# sourceMappingURL=index.js.map